import { render, staticRenderFns } from "./TeethDiagram.vue?vue&type=template&id=81e69ae8&scoped=true"
import script from "./TeethDiagram.vue?vue&type=script&lang=js"
export * from "./TeethDiagram.vue?vue&type=script&lang=js"
import style0 from "./TeethDiagram.vue?vue&type=style&index=0&id=81e69ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e69ae8",
  null
  
)

export default component.exports